import { createSelector } from 'reselect';

import { LessonViewStore } from 'common.components/lesson-view.store/interfaces';

const lessonViewStateSelector = (storeState: any): LessonViewStore => storeState.lessonView;

export const getShouldShowNotification = createSelector(
    [lessonViewStateSelector],
    (state: LessonViewStore): boolean => state.shouldShowNotification
);

export const getNotificationsTextId = createSelector(
    [lessonViewStateSelector],
    (state: LessonViewStore): string | null => state.notificationTextId
);
